<template>
  <div class="card-text-card-actions-wrapper d-flex flex-column">
    <v-card-text class="px-3 px-sm-6 pb-0">
      <v-container class="px-0">
        <v-form ref="resetPasswordForm" @submit.prevent>
          <v-row>
            <v-col cols="12" class="pt-0 pb-1">
              <default-text-field
                ref="newPassword"
                v-model.trim="newPassword"
                :rules="validationRules('newPassword')"
                :label="$t('newPassword')"
                type="password"
                @keydown.space.prevent
              >
                <template #append-outer>
                  <text-popover
                    :text="$t('validPasswordExplanation')"
                  ></text-popover>
                </template>
              </default-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-0 pb-1">
              <default-text-field
                v-model.trim="repeatPassword"
                :rules="validationRules('repeatPassword')"
                :label="$t('repeatPassword')"
                type="password"
                @keydown.space.prevent
              >
              </default-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="d-flex justify-end px-6 py-3">
      <v-btn
        color="primary"
        :disabled="newPassword.length < 4 || !passwordsAreEqual"
        @click="savePassword"
      >
        {{ $t("save") }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { axiosPost } from "@/api/requests";
import handleErrorStatus from "@/mixins/handleErrorStatus";
import snackBarMessages from "@/mixins/snackBarMessages";
import DefaultTextField from "@/components/formFields/DefaultTextField";
import TextPopover from "@/components/globals/TextPopover";
import { mapState } from "vuex";

export default {
  name: "ResetPassword",
  components: {
    DefaultTextField,
    TextPopover,
  },
  mixins: [snackBarMessages, handleErrorStatus],
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      newPassword: "",
      repeatPassword: "",
    };
  },
  computed: {
    passwordsAreEqual() {
      return this.newPassword === this.repeatPassword;
    },
    ...mapState(["user"]),
  },
  watch: {
    showDialog: {
      immediate: true,
      handler(val) {
        this.newPassword = "";
        this.repeatPassword = "";
        if (this.$refs.resetPasswordForm) {
          this.$refs.resetPasswordForm.resetValidation();
        }
        if (val) {
          setTimeout(() => {
            this.$refs.newPassword.$children[0].$refs.input.focus();
          }, 300);
        }
      },
    },
  },
  methods: {
    savePassword() {
      if (this.$refs.resetPasswordForm.validate()) {
        this.$root.$loader.open(this.$t("savingNewPassword"));
        const url =
          process.env.VUE_APP_IDENTITY_URL + "/authentication/SetPassword";
        const data = {
          accountId: this.user.accountID,
          password: this.newPassword,
        };
        axiosPost(url, data, this.user.authToken)
          .then((response) => {
            this.handleSavePasswordResponse(response);
          })
          .catch((error) => {
            console.log(error);
            this.snackbarError(this.$t("newPasswordSaveFailed"));
          })
          .finally(() => {
            this.$root.$loader.close();
          });
      } else {
        this.snackbarInvalidForm();
      }
    },
    handleSavePasswordResponse(response) {
      if (response.status && response.status !== 200) {
        this.handleErrorStatus(response.status);
      } else if (response.success) {
        this.snackbarSucces(this.$t("newPasswordSaveSuccess"));
        this.$emit("close-dialog");
      } else if (response.errorMsg) {
        this.snackbarError(
          this.$t("newPasswordSaveFailed") + " :" + response.errorMsg
        );
      } else {
        this.snackbarError(this.$t("newPasswordSaveFailed"));
      }
    },
    validationRules(fieldname) {
      switch (fieldname) {
        case "newPassword":
          return [
            (v) => !!v || this.$t("requiredFieldError"),
            (v) =>
              (v.trim().length > 6 &&
                /.*[A-Z].*/.test(v) &&
                /.*[a-z].*/.test(v) &&
                /.*\d.*/.test(v) &&
                /.*[!@#$%^&+=();:.,~?<>].*/.test(v) &&
                /^[^\\\/\'\"\`-]*$/.test(v) &&
                /^\S*$/.test(v)) ||
              this.$t("newPasswordInvalid"),
          ];
        case "repeatPassword":
          return [this.passwordsAreEqual || this.$t("passwordsDontMatch")];
      }
    },
  },
};
</script>
